webpackJsonp([6,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var Shared = __webpack_require__(39);
	var Carousel = __webpack_require__(222);
	var Utils = __webpack_require__(25);
	
	__webpack_require__(919);
	
	$(function () {
	  Shared.init();
	  IndexPage.init();
	});
	
	var IndexPage = {};
	
	(function (IndexPage) {
	  var carousel;
	  IndexPage.init = function () {
	    carousel = new Carousel({
	      element: $(".carousel-wrapper"),
	      clickCallBack: onCarouselClicked
	    });
	
	    Utils.ImageSVGToSVG();
	  };
	
	  function onCarouselClicked(e) {
	    var el = $(e.currentTarget).find(".figurine-slide");
	
	    window.location = "/figurines#" + el.data("figurine-id");
	  }
	})(IndexPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./fr-BE.json": 42,
		"./nl-BE.json": 43
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 37;


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./figurine_astrid.png": 344,
		"./figurine_bea.png": 345,
		"./figurine_caroline.png": 346,
		"./figurine_corinne.png": 347,
		"./figurine_cornelus.png": 348,
		"./figurine_didier.png": 349,
		"./figurine_diego.png": 350,
		"./figurine_gerry.png": 351,
		"./figurine_henry.png": 352,
		"./figurine_herbert.png": 353,
		"./figurine_karla.png": 354,
		"./figurine_kitou.png": 355,
		"./figurine_leon.png": 356,
		"./figurine_martin.png": 357,
		"./figurine_maurice.png": 358,
		"./figurine_max.png": 359,
		"./figurine_milla.png": 360,
		"./figurine_olga.png": 361,
		"./figurine_pol.png": 362,
		"./figurine_renee.png": 363,
		"./figurine_ric.png": 364,
		"./figurine_sam.png": 365,
		"./figurine_viktor.png": 366,
		"./figurine_waldo.png": 367
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 221;


/***/ }),

/***/ 919:
907

});


// WEBPACK FOOTER //
// js/index.4a57f87dec496f352b57.js